﻿import { useMutation, useQueryClient } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';
import type { IAdminMessageSendPayload } from '@/interfaces';

type TParams = {
  onSuccess?: () => void;
};

type TDataVariables = IAdminMessageSendPayload;
type TResponseData = { adminMessageId: string };

export const useRequestSendAdminMessage = (params?: TParams) => {
  const queryClient = useQueryClient();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.adminMessages],
    mutationFn: (data: TDataVariables) =>
      apiClient
        .post<TResponseData>(routes.api.adminMessages, data)
        .then(handleApiResponse),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [routes.api.adminMessagesList] });
      params?.onSuccess?.();
    }
  });

  const triggerSendAdminMessage = (data: TDataVariables) => mutateAsync(data);

  return {
    isLoading: isPending,
    triggerSendAdminMessage,
    error
  };
};
